module.exports = __webpack_public_path__ + "img/logo.b96dbed3.svg";